(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-get-menu"] && !Shopify.designMode) return;
  try {
    function initializeGtNavigation(){
document.querySelectorAll('.gt-nav').forEach(nav=>{
if(nav.dataset.hoverReady)return;
nav.dataset.hoverReady='true';
const desktop=window.matchMedia('(min-width:1025px) and (hover:hover) and (pointer:fine)');
nav.querySelectorAll('details').forEach(item=>{
let closeTimer;
const summary=item.querySelector('summary');
item.addEventListener('pointerenter',event=>{
if(!desktop.matches||event.pointerType!=='mouse')return;
clearTimeout(closeTimer);
nav.querySelectorAll('details[open]').forEach(other=>{if(other!==item)other.open=false;});
item.open=true;
});
item.addEventListener('pointerleave',event=>{
if(!desktop.matches||event.pointerType!=='mouse')return;
clearTimeout(closeTimer);
closeTimer=setTimeout(()=>{item.open=false;},120);
});
summary.addEventListener('click',event=>{
if(desktop.matches&&event.detail>0){event.preventDefault();item.open=true;}
});
item.addEventListener('focusout',()=>{setTimeout(()=>{if(!item.contains(document.activeElement)&&!item.matches(':hover'))item.open=false;},0);});
});
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeGtNavigation);else initializeGtNavigation();
document.addEventListener('shopify:section:load',initializeGtNavigation);
document.addEventListener('click',event=>{document.querySelectorAll('.gt-nav details[open]').forEach(item=>{if(!item.contains(event.target)||event.target.closest('a'))item.open=false;});});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.gt-nav details[open]').forEach(item=>{item.open=false;item.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

})();
